<template>
  <q-dialog ref="dialogRef" @hide="onDialogHide" persistent>
    <q-card class="my-font">
      <q-card-section class="text-center">
        <div class="text-h6 text-bold">Pilih Staff</div>
        <div class="text-grey-8">
          Pilih staff yang akan melakukan {{ data.process_name }}
        </div>
      </q-card-section>

      <q-card-section class="q-pt-none row items-center q-gutter-x-md">
        <div>Staff</div>
        <q-select
          outlined
          dense
          use-input
          map-options
          emit-value
          class="l-grow"
          v-model="data.selStaff"
          :options="data.filteredStaff"
          @filter="filterFn"
        />
      </q-card-section>

      <q-card-actions align="center">
        <q-btn
          outline
          no-caps
          dense
          label="Batalkan"
          color="brand"
          v-close-popup
        />
        <q-btn
          unelevated
          no-caps
          dense
          text-color="white"
          label="Konfirmasi"
          color="brand"
          :disable="!data.selStaff"
          @click="onOKClick"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { useDialogPluginComponent } from "quasar";
import useBasic from "@/composables/useBasic";

export default {
  props: ["process_name"],

  emits: [
    // REQUIRED; need to specify some events that your
    // component will emit through useDialogPluginComponent()
    ...useDialogPluginComponent.emits,
  ],

  setup(props) {
    const { $http, onMounted, reactive } = useBasic();

    onMounted(async () => {
      await getStaff();
    });

    let data = reactive({
      optStaff: [],
      filteredStaff: [],
      selStaff: null,
      process_name: props.process_name,
    });

    let filterFn = (val, update, abort) => {
      update(() => {
        const needle = val.toLowerCase();
        data.filteredStaff = data.optStaff.filter(
          (v) => v.label.toLowerCase().indexOf(needle) > -1
        );
      });
    };

    let getStaff = async () => {
      let resp = await $http.get(`/setting/list-staff`);
      data.optStaff = resp.data;
    };

    const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } =
      useDialogPluginComponent();

    return {
      data,

      dialogRef,
      onDialogHide,
      filterFn,

      onOKClick() {
        onDialogOK({ id_staff: data.selStaff });
      },

      // we can passthrough onDialogCancel directly
      onCancelClick: onDialogCancel,
    };
  },
};
</script>
